'use strict';

import { merge } from 'lodash';
import df from 'deep-freeze';

import sharedConfig from './shared-config';


export default df(merge({
    debug: {
        level: 'warn',
    },
}, sharedConfig));
